module.exports = __webpack_public_path__ + "img/branch-particle-09.fd3eca60.png";